import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { initializeStore } from '@/redux/store';
import initialState from '@/redux/av-check/initial-state';
import reducer from '@/redux/av-check/reducer';

import Site from './components/Site';

(() => {
  const mountPoint = document.querySelector('#root');

  if (!mountPoint) {
    console.log('no \'#root\' element found');
    return;
  }
  let encodedServiceUrl = null;
  let encodedShopContext = null;

if(mountPoint.getAttribute('data-service-url') !== null) {
   encodedServiceUrl = mountPoint.getAttribute('data-service-url')?.replace(/(\r\n|\n|\r)/gm, "");
}

   const serviceUrl = encodedServiceUrl;
    if (!serviceUrl) {
      console.log('no \'service url\' found');
      return ;
    }

  if(mountPoint.getAttribute('data-shop-context')!==null) {
    encodedShopContext = mountPoint.getAttribute('data-shop-context')?.replace(/(\r\n|\n|\r)/gm, "");
  }

  const  shopContext = encodedShopContext;
    if (!shopContext) {
      console.log('no \'shop context\' found');
      return;
    }

  const store = initializeStore(initialState, reducer);

  ReactDOM.render(
    <Provider store={store}>
      <Site serviceUrl={serviceUrl} shopContext={shopContext} selectedRouter="" selectedPack="" hardwareOfferName="" />
    </Provider>,
    mountPoint,
  );
})();
